export default {"src":"/_next/static/media/logoHeaderSpanish.01a12543.svg","height":189,"width":204,"blurWidth":0,"blurHeight":0};